import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authdApiRequest } from '../utils/api';
import Layout from '../components/Layout';

function OrganizationsForm() {
  const { id } = useParams();
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTeam = async () => {
      if (id) {
        try {
          const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/organizations/${id}`);
          const data = await response.json();
          setName(data.name);
          setSlug(data.slug);
        } catch (error) {
          console.error('Error fetching team:', error);
          toast.error('Failed to load team data.');
        }
      }
    };

    fetchTeam();
  }, [id]);

  useEffect(() => {
    document.title = id ? `Edit Organization - ${name} - DevWing` : 'Add New Organization - DevWing';
  }, [id, name, slug]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const method = id ? 'PUT' : 'POST';
    const url = id ? `${process.env.REACT_APP_API_HOST}/organizations/${id}` : `${process.env.REACT_APP_API_HOST}/organizations`;

    try {
      await authdApiRequest(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, slug }),
      });
      toast.success(`Organization ${id ? 'updated' : 'added'} successfully!`);
      navigate('/organizations');
    } catch (error) {
      console.error('Error saving organization:', error);
      toast.error('Failed to save organization.');
    }
  };

  return (
    <Layout>
      <h1 className="text-2xl mb-8 font-bold">{id ? 'Edit Organization' : 'Add New Organization'}</h1>
      <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
        <input
          type="text"
          placeholder="Organization Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="p-2 border"
        />
        <input
          type="text"
          placeholder="Organization Slug"
          value={slug}
          onChange={(e) => {
            const value = e.target.value;
            // Allow only letters and numbers, and limit to 32 characters
            if (/^[a-zA-Z0-9]*$/.test(value) && value.length <= 32) {
              setSlug(value);
            }
          }}
          className="p-2 border"
          maxLength={32} // Limit to 32 characters
        />
        <button type="submit" className="p-2 bg-sky-500 text-white">
          {id ? 'Update Organization' : 'Add Organization'}
        </button>
      </form>
    </Layout>
  );
}

export default OrganizationsForm;
